import gql from "graphql-tag";

export const cookieValueFieldsFragment = gql`
  fragment CookieValueFields on CookieValue {
    name
    value
    expires
    secure
    sameSite
    path
  }
`;
